import { Alert } from "@jugl-web/ui-components/cross-platform/Alert";
import { Button } from "@jugl-web/ui-components/cross-platform/Button";
import { MobileDrawer } from "@jugl-web/ui-components/mobile/MobileDrawer";
import { useAppVariant, useTranslations } from "@jugl-web/utils";
import { FC } from "react";

interface TaskChecklistItemDeleteConfirmationDialogProps {
  isOpen: boolean;
  onDelete: () => void;
  onClose: () => void;
}

export const TaskChecklistItemDeleteConfirmationDialog: FC<
  TaskChecklistItemDeleteConfirmationDialogProps
> = ({ isOpen, onDelete, onClose }) => {
  const { isMobile } = useAppVariant();
  const { t } = useTranslations();

  const labels = {
    title: t({
      id: "tasks-page.delete-task-checklist-item-confirmation-title",
      defaultMessage: "Delete checklist item",
    }),
    message: t({
      id: "tasks-page.delete-task-checklist-item-confirmation-description",
      defaultMessage: "Are you sure you want to delete this checklist item?",
    }),
    delete: t({
      id: "common.delete",
      defaultMessage: "Delete",
    }),
    cancel: t({
      id: "common.cancel",
      defaultMessage: "Cancel",
    }),
  };

  if (isMobile) {
    return (
      <MobileDrawer
        isOpen={isOpen}
        header={{ title: labels.title }}
        onClose={onClose}
      >
        <MobileDrawer.Content>
          <p className="text-onyx mt-2 mb-10 text-sm leading-[21px]">
            {labels.message}
          </p>
          <div className="flex flex-col gap-2.5">
            <Button
              color="primary"
              variant="contained"
              onClick={onDelete}
              uppercase
            >
              {labels.delete}
            </Button>
            <Button color="primary" variant="text" onClick={onClose} uppercase>
              {labels.cancel}
            </Button>
          </div>
        </MobileDrawer.Content>
      </MobileDrawer>
    );
  }

  return (
    <Alert
      isOpen={isOpen}
      title={labels.title}
      content={labels.message}
      buttons={[
        {
          text: labels.cancel,
          role: "close",
        },
        {
          text: labels.delete,
          color: "tertiary",
          onClick: onDelete,
        },
      ]}
      onRequestClose={onClose}
    />
  );
};
